import { useStatsigClient } from '@statsig/react-bindings';
import { useEffect } from 'react';

import Gates from '../statsig/gates';

export const useTagManager = (productUUID?: string) => {
  const { checkGate } = useStatsigClient();

  useEffect(() => {
    if (!productUUID || !checkGate(Gates.TagManager)) {
      return;
    }

    if (document.getElementById('imprint-gtm-script')) {
      return;
    }

    const script = document.createElement('script');
    script.id = 'imprint-gtm-script';
    script.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-TFXM7F5C');
    `;
    document.head.prepend(script);

    const noscript = document.createElement('noscript');
    noscript.id = 'imprint-gtm-noscript';
    noscript.innerHTML = `
      <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-TFXM7F5C"
      height="0" width="0" style="display:none;visibility:hidden"></iframe>
    `;
    document.body.prepend(noscript);

    return () => {
      const scriptEl = document.getElementById('imprint-gtm-script');
      if (scriptEl && scriptEl.parentNode) {
        scriptEl.parentNode.removeChild(scriptEl);
      }
      const noscriptEl = document.getElementById('imprint-gtm-noscript');
      if (noscriptEl && noscriptEl.parentNode) {
        noscriptEl.parentNode.removeChild(noscriptEl);
      }
    };
  }, [productUUID, checkGate]);
};
